import { Modal } from 'antd';
import styled from 'styled-components';

/** Dedicated shell so reconnect is not dragged by AddToPlayList modal offsets. */
export const SpotifyReconnectModalStyle = styled(Modal)`
  /* Pin near the top of the viewport (not bottom-sunk). */
  top: 12vh !important;
  padding-bottom: 0;

  .ant-modal-content {
    background: #111823;
    border: 1px solid #ffffff4d;
    border-radius: 20px;
    color: ${(props) => props.theme?.colors?.primary || '#fff'};
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.45);
  }

  .ant-modal-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 24px 20px;
  }

  .ant-modal-close {
    color: rgba(255, 255, 255, 0.65);
  }

  .ant-modal-close:hover {
    color: #fff;
  }

  .heading {
    color: ${(props) => props.theme?.colors?.primary || '#fff'};
    font-family: Poppins, sans-serif;
    font-size: 16px;
    font-weight: 500;
    margin: 0 0 4px;
    text-align: left;
  }

  .body-text {
    margin: 0;
    font-family: 'Public Sans', sans-serif;
    font-size: 13px;
    font-weight: 300;
    line-height: 1.55;
    color: rgba(255, 255, 255, 0.72);
    text-align: left;
  }

  .body-text strong {
    font-weight: 600;
    color: rgba(255, 255, 255, 0.92);
  }

  .footer-actions {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
    width: 100%;
  }

  /* Override FilledButtonStyle width:100% so buttons sit side-by-side, not stacked. */
  .footer-actions .btn-cancel,
  .footer-actions .btn-confirm {
    display: inline-flex !important;
    height: 40px !important;
    min-height: 40px !important;
    width: auto !important;
    max-width: none !important;
    flex: 0 0 auto !important;
    white-space: nowrap !important;
    padding: 0 18px !important;
    font-size: 13px !important;
    border-radius: 8px;
  }

  .footer-actions .btn-cancel {
    min-width: 96px;
    background: transparent !important;
    border: 1px solid rgba(255, 255, 255, 0.35) !important;
    color: #fff !important;
  }

  .footer-actions .btn-cancel:hover {
    border-color: rgba(255, 255, 255, 0.6) !important;
  }

  .footer-actions .btn-confirm {
    min-width: 96px;
    background: #007aff !important;
    color: #fff !important;
    border: none !important;
  }

  .footer-actions .btn-confirm:hover {
    filter: brightness(1.08);
  }
`;
